// Simple reducer to replace state in original CreateFormModal class component

import { InventorySchemaItem } from '@atom/types/schema';

export interface CreateFormModalState {
  open: boolean;
  errors: {
    name: string;
  };
  name: string;
  rootSchema: InventorySchemaItem | null;
}

export const initialState: CreateFormModalState = {
  open: false,
  rootSchema: null,
  errors: {
    name: '',
  },
  name: '',
};

export const formModalStateReducer = (state: CreateFormModalState, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.data };
    default: {
      return state;
    }
  }
};
